import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';

import element1 from './Images/shape-1.png';
import element2 from '../../assets/about-shape2.png';
import element3 from './Images/shape-2.png';
import HeroImage from './Images/hero-img.png';
import css from './AboutPage.module.css';
import { isLocaleGreek, onSendEmail } from '../../util/genericHelpers';
import { NamedLink, PrimaryButton } from '../../components';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { createResourceLocatorString } from '../../util/routes';
import routeConfiguration from '../../routing/routeConfiguration';

function SectionHero() {
  const history = useHistory();

  const onRedirectToPage = (page, params = {}) => {
    history.push(createResourceLocatorString(page, routeConfiguration(), params, {}));
  };
  return (
    <>
      <div className={css.heroWrapper}>
        <span className={css.shape1}>
          <img src={element1} alt="element" />
        </span>
        <span className={css.shape2}>
          <img src={element3} alt="element" />
        </span>
        <div className={css.fixedWidthContainer}>
          <div className={css.heroImg}>
            <img src={HeroImage} alt="Vivian lab" />
          </div>
          <div className={css.heroContent}>
            <h2>
              <FormattedMessage id="AboutPage.heading" />
            </h2>
            <p>
              <FormattedMessage id="AboutPage.description" />
            </p>
            {/*<div className={css.buttonWrapper}>*/}
            {/*  <PrimaryButton*/}
            {/*    className={css.bookBtn}*/}
            {/*    type="button"*/}
            {/*    onClick={() => onRedirectToPage('ContactPage')}*/}
            {/*  >*/}
            {/*    <FormattedMessage id="CompaniesPage.registerButton" />*/}
            {/*  </PrimaryButton>*/}
            {/*</div>*/}
          </div>
        </div>
      </div>
    </>
  );
}

export default SectionHero;
